import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fileUrl } from "../lib/api";
import { SectionTitle } from "../components/shared";
import { Card } from "../components/ui/card";
import { ArrowRight } from "lucide-react";
import { Seo } from "../lib/seo";

export default function Categorie() {
  const [categories, setCategories] = useState([]);
  useEffect(() => { api.get("/categories").then(({ data }) => setCategories(data)); }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 py-12">
      <Seo title="Categorie Prodotti Herbalife | Herbalife Rossano" description="Esplora le categorie di prodotti Herbalife: colazione e Formula 1, controllo peso, sport, benessere e cura della persona. Acquista online a Rossano e Corigliano-Rossano." canonical="/categorie" />
      <SectionTitle eyebrow="Sfoglia" title="Categorie" subtitle="Esplora i prodotti per categoria." />
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories.map((c) => (
          <Link key={c.id} to={`/catalogo?category=${c.id}`} className="group" data-testid={`category-${c.id}`}>
            <Card className="overflow-hidden rounded-2xl border-slate-200 hover:shadow-xl transition-all">
              <div className="aspect-[16/9] bg-emerald-50 overflow-hidden flex items-center justify-center">
                {fileUrl(c.image_url) ? <img src={fileUrl(c.image_url)} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <span className="text-4xl font-display font-extrabold text-emerald-200">{c.name[0]}</span>}
              </div>
              <div className="p-5">
                <h3 className="font-display font-bold text-lg text-slate-900 group-hover:text-primary flex items-center justify-between">{c.name} <ArrowRight className="w-4 h-4" /></h3>
                {c.description && <p className="mt-1 text-sm text-slate-500 line-clamp-2">{c.description}</p>}
              </div>
            </Card>
          </Link>
        ))}
        {!categories.length && <p className="text-slate-400">Nessuna categoria disponibile.</p>}
      </div>
    </div>
  );
}
